import useTranslation from 'hooks/useTranslation'
import React from 'react'
import './style.scss'

interface MagNumberProps {
  number: string | number
  isShared?: boolean
  isDesktop?: boolean
  acronym?: string
  isLight?: boolean
}

const MagNumber: React.FC<MagNumberProps> = ({ number, isLight, isShared, acronym, isDesktop = false }) => {
  const { t } = useTranslation('basic')

  return (
    <div className={`mag__number ${isLight ? 'light' : ''}`}>
      <div className='mag__number__top'>
        <div className='mag__icon'>
          <i className='icon icon--mag-number'></i>
        </div>
        <div className='mag__desc'>
          <span>{t('numberShort')}</span>
          <div className='--secFont'>{number}</div>
        </div>
      </div>

      {isShared && <div
        className='mag__number__bottom'
        style={isDesktop ? { paddingTop: '1em' } : {}}>
        <i className='icon icon--share' />
        {isDesktop && <span>Udostępnione od: </span>}
        <span>{acronym}</span>
      </div>}
    </div>
  )
}

export default MagNumber